import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19h1.341a7 7 0 0 0 6.845 -5.533l.628 -2.934a7 7 0 0 1 6.846 -5.533h1.34","key":"svg-0"}]]

const IconStrokeCurved = createReactComponent('outline', 'stroke-curved', 'StrokeCurved', __iconNode);

export default IconStrokeCurved;